import React from 'react';
import RoutedListingInner, { RoutedListingProps } from './RoutedListingInner';

const RoutedListing: React.FunctionComponent<RoutedListingProps> = function (props) {
    return <RoutedListingInner {...props} />;
};

export default RoutedListing;
